import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Tab from './utils/tabSwitch'
import Filter from './utils/filters';
import Global from './utils/global'
import echarts from 'echarts'
import {
	log
} from 'util';
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import './assets/css/index.less'
import confirmDialog from '@/components/confirmDialog'
import DialogManage from '@/components/dialogManage'
import redstarcloudUi from 'redstarcloud-ui'
import 'redstarcloud-ui/dist/redstarcloud-ui.css'
import rsMessageToast from '../src/components/rsMessageToast/src/index'
import store from "@/store";
import vueiInfinite from 'vue-infinite-scroll'
import allDirective from './utils/allDirective'
import VueResource from 'vue-resource'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)
// const originalPush = router.prototype.push

// router.prototype.push = function push (location) {

// return originalPush.call(this, location).catch(err => err)

// }
// import { Message } from 'redstarcloud-ui';
// import statu from './status.js'
// import routerUtil from "./utils/routerutil.js";//先将js文件在main.js中引入
// routerUtil(router);
// import Testing from '@/utils/testing'
// Vue.use(statu)
// Vue.use(Message)
Vue.use(VueResource)
Vue.use(vueiInfinite)
Vue.use(redstarcloudUi)
Vue.use(rsMessageToast)
allDirective(Vue)
let bus = new Vue()
Vue.prototype.bus = bus

require('es6-promise').polyfill()
Es6Promise.polyfill()
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

Vue.prototype.$confirmDialog = confirmDialog
Vue.prototype.$dialogManage = DialogManage

Vue.use(Tab)
Vue.use(Global)
Vue.use(Filter)
// router.beforeEach((to, from, next) => {
// 	if (to.matched.some(record => record.meta.requiresAuth)) {
// 		//这里判断用户是否登录，验证本地存储是否有shopIo
// 		if (!localStorage.getItem('shopVo')) { // 判断当前的shopIo是否存在
// 			alert('您还未登录')
// 			next({
// 				path: '/paymentLogin',
// 				// query: { redirect: to.fullPath }
// 			})
// 		} else {
// 			next()
// 		}
// 	} else {
// 		next() // 确保一定要调用 next()
// 	}
// })
// router.beforeEach((to, from, next) => {
 
//   const type = to.meta.type
//   // 判断该路由是否需要登录权限
//   if (type === 'login') {
// 	  console.log(type)
//     if (localStorage.getItem('shopVo')) {
// 		console.log(localStorage.getItem('shopVo'))
//       next()
//     } else {
// 		// alert('登录超时')
// 		// alert('登陆超时，请重新登录')
// 		//   // top.$message.error('登录超时');
// 		  // router.go(0)
// 		  // window.location.onload(),
//      next(
	 
// 		  {
// 			  path:'/paymentLogin',
			 
// 		  }
	 
//      )
	 
//     }
//   } else {
//     next()  // 确保一定要有next()被调用
//   }
// })

/* eslint-disable */
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')

